import React, {useContext, useState} from "react";
import {saveData} from "../../helpers/Api";
import {Button, Col, Row, Tab, Tabs} from "react-bootstrap";
import FlashMessage from "../shared/FlashMessage";
import {useMutation} from "@apollo/client";
import {updateProfileQuery} from "./UserQueries";
import UploadFile from "../shared/UploadFile";
import {AuthContext} from "../../context/authContext";
import AllergyList from "../client/allergies/AllergyList";
import MedicationList from "../client/medications/MedicationList";
import DiseaseList from "../client/diseases/DiseaseList";
import BadIngredientsList from "../client/bad_ingredients/BadIngredientsList";

const ClientProfile = () => {
  const [flash, setFlash] = useState({});
  const [updateCall] = useMutation(updateProfileQuery)
  const { saveUser, user } = useContext(AuthContext)

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: updateCall,
      query_key: 'updateUser',
      flash_callback: setFlash,
      success: (res) => {
        saveUser(res.user)
      }
    })
  }

  const onAvatarChange = (res) => {
    saveUser({ ...user, avatar: res.path })
  }

  return (
    <div className="container mb-4">
      <div className='d-sm-flex align-items-center mb-5 mt-4'>
        <Col className='flex-shrink-0 me-2 py-3'>
          {user.email &&
            <UploadFile model='Client' id={user.id} field='avatar'
                        filePath={user.avatar} onChange={onAvatarChange} />}
        </Col>
        <Col sm={7} className='flex-grow-1 border p-3 rounded shadow bg-body'>
          <form onSubmit={onSubmit}>
            <Row className="mb-2">
              <Col>
                <label htmlFor="fName">Prenume</label>
                <input type='text' name='fName' className="form-control" id="fName" defaultValue={user.fName} />
              </Col>
              <Col>
                <label htmlFor="lName">Nume</label>
                <input type="text" name='lName' className="form-control" id="lName" defaultValue={user.lName} />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <label htmlFor="phone">Telefon</label>
                <input type="text" name='phone' className="form-control" id="phone" defaultValue={user.phone} />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <label htmlFor="email">Email</label>
                <input type="email" name="email" className="form-control" id="email" defaultValue={user.email} />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <label htmlFor="password">Parola</label>
                <input type="password" name="password" className="form-control" id="password" defaultValue='' />
              </Col>
            </Row>
            <FlashMessage flash={flash} buttons={<Button type='submit' className='float-end'>Salveaza</Button>} />
          </form>
        </Col>
      </div>

      <Tabs>
        <Tab eventKey='diseases' title='Afectiuni'>
          <div className='border border-top-0 p-3 rounded-bottom shadow'>
            <DiseaseList user={user} />
          </div>
        </Tab>
        <Tab eventKey='medications' title='Medicamente'>
          <div className='border border-top-0 p-3 rounded-bottom shadow'>
            <MedicationList user={user} />
          </div>
        </Tab>
        <Tab eventKey='allergies' title='Alergii'>
          <div className='border border-top-0 p-3 rounded-bottom shadow'>
            <AllergyList user={user} />
          </div>
        </Tab>
        <Tab eventKey='badIngredients' title='Nu pot manca'>
          <div className='border border-top-0 p-3 rounded-bottom shadow'>
            <BadIngredientsList user={user} />
          </div>
        </Tab>
      </Tabs>
    </div>
  );
}

export default ClientProfile
